import { Library, Radio } from "lucide-react";
import { STUDIO } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const StudioExperienceSection = () => {
  return (
    <section
      data-testid="studio-experience-section"
      className="section"
      style={{ backgroundColor: "var(--bg-2)" }}
    >
      <div className="container-fx">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center">
          <Reveal>
            <div>
              <p className="eyebrow">{STUDIO.eyebrow}</p>
              <h2
                className="display mt-5"
                style={{ fontSize: "clamp(2.2rem, 5vw, 3.6rem)", fontWeight: 500 }}
              >
                {STUDIO.headline_lead}{" "}
                <span className="accent-italic">{STUDIO.headline_accent}</span>
              </h2>
              <p
                className="mt-6 max-w-xl"
                style={{
                  color: "var(--text-2)",
                  fontSize: "1rem",
                  lineHeight: 1.7,
                }}
              >
                {STUDIO.body}
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div
              className="p-7 sm:p-9"
              style={{
                backgroundColor: "var(--surface-2)",
                border: "1px solid var(--border-c)",
                borderRadius: "var(--radius-lg)",
              }}
            >
              <div className="flex items-center gap-3">
                <Radio size={18} style={{ color: "var(--bronze)" }} />
                <p className="eyebrow" style={{ color: "var(--muted)" }}>
                  {STUDIO.scheduleTitle}
                </p>
              </div>
              <div className="mt-5 space-y-4">
                {STUDIO.schedule.map((s) => (
                  <div
                    key={s.days}
                    className="grid items-baseline gap-4 pb-4"
                    style={{
                      borderBottom: "1px solid var(--border-c)",
                      gridTemplateColumns: "minmax(0, 1fr) minmax(7rem, 9rem)",
                    }}
                  >
                    <span
                      className="font-serif"
                      style={{
                        color: "var(--text)",
                        fontSize: "1.2rem",
                        minWidth: 0,
                      }}
                    >
                      {s.days}
                    </span>
                    <span
                      style={{
                        color: "var(--bronze)",
                        display: "block",
                        fontFamily: "var(--font-sans)",
                        letterSpacing: "0.06em",
                        fontSize: "0.95rem",
                        lineHeight: 1.35,
                        textAlign: "right",
                        width: "100%",
                      }}
                    >
                      {s.times}
                    </span>
                  </div>
                ))}
              </div>
              <div className="mt-6 flex items-center gap-3">
                <Library size={18} style={{ color: "var(--bronze)" }} />
                <span
                  style={{
                    color: "var(--text-2)",
                    fontSize: "0.92rem",
                    letterSpacing: "0.02em",
                  }}
                >
                  {STUDIO.access}
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
